import React from 'react';
import { useI18n } from '../lib/i18n';
export function Footer() {
  const {
    t
  } = useI18n();
  return <footer className="bg-luxury-espresso py-12 border-t border-white/5" data-id="element-14">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-15">
        <div className="flex items-center gap-6 text-xs text-luxury-white/50" data-id="element-16">
          <a href="#" className="hover:text-luxury-white transition-colors" data-id="element-17">
            {t('terms')}
          </a>
          <a href="#" className="hover:text-luxury-white transition-colors" data-id="element-18">
            {t('privacy')}
          </a>
        </div>

        <div className="text-xs text-luxury-white/50 tracking-widest uppercase" data-id="element-19">
          {t('collab')}
        </div>

        <div className="text-xs text-luxury-white/50" data-id="element-20">
          &copy; {new Date().getFullYear()} Emelyn De Martino.
        </div>
      </div>
    </footer>;
}